import React from 'react';

import LinksPageLayout
  from 'components/dashboard/links-content/links-layout/LinksPageLayout';
import SocialPageContent
  from 'components/dashboard/social-content/SocialPageContent';


const DashboardSocialLinksPage = () => (
  <LinksPageLayout activeLinksPage="social">
    <SocialPageContent />
  </LinksPageLayout>
);

export default DashboardSocialLinksPage;
